import { render, staticRenderFns } from "./Instalacoes.vue?vue&type=template&id=27f16852"
import script from "./Instalacoes.vue?vue&type=script&lang=js"
export * from "./Instalacoes.vue?vue&type=script&lang=js"
import style0 from "./Instalacoes.vue?vue&type=style&index=0&id=27f16852&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports